var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.index-of");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var unified = require('unified');

var toMDAST = require('remark-parse');

var squeeze = require('remark-squeeze-paragraphs');

var toMDXAST = require('./md-ast-to-mdx-ast');

var mdxAstToMdxHast = require('./mdx-ast-to-mdx-hast');

var mdxHastToJsx = require('./mdx-hast-to-jsx');

var _require = require('./util'),
    isImport = _require.isImport,
    isExport = _require.isExport,
    isExportDefault = _require.isExportDefault,
    BLOCKS_REGEX = _require.BLOCKS_REGEX,
    EMPTY_NEWLINE = _require.EMPTY_NEWLINE;

var DEFAULT_OPTIONS = {
  footnotes: true,
  mdPlugins: [],
  hastPlugins: [],
  compilers: [],
  blocks: [BLOCKS_REGEX]
};

var tokenizeEsSyntax = function tokenizeEsSyntax(eat, value) {
  var index = value.indexOf(EMPTY_NEWLINE);
  var subvalue = index !== -1 ? value.slice(0, index) : value;

  if (isExport(subvalue)) {
    return eat(subvalue)({
      type: 'export',
      "default": isExportDefault(subvalue),
      value: subvalue
    });
  }

  if (isImport(subvalue)) {
    return eat(subvalue)({
      type: 'import',
      value: subvalue
    });
  }
};

tokenizeEsSyntax.locator = function (value, _fromIndex) {
  return isExport(value) || isImport(value) ? -1 : 1;
};

function esSyntax() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  tokenizers.esSyntax = tokenizeEsSyntax;
  methods.splice(methods.indexOf('paragraph'), 0, 'esSyntax');
}

function createMdxAstCompiler(options) {
  var mdPlugins = options.mdPlugins;
  var fn = unified().use(toMDAST, options).use(esSyntax).use(squeeze, options);
  mdPlugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      fn.use(plugin[0], plugin[1]);
    } else {
      fn.use(plugin, options);
    }
  });
  fn.use(toMDXAST, options).use(mdxAstToMdxHast, options);
  return fn;
}

function applyHastPluginsAndCompilers(compiler, options) {
  var hastPlugins = options.hastPlugins;
  var compilers = options.compilers;
  hastPlugins.forEach(function (plugin) {
    // Handle [plugin, pluginOptions] syntax
    if (Array.isArray(plugin) && plugin.length > 1) {
      compiler.use(plugin[0], plugin[1]);
    } else {
      compiler.use(plugin, options);
    }
  });
  compiler.use(mdxHastToJsx, options);

  var _iterator = _createForOfIteratorHelper(compilers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var compilerPlugin = _step.value;
      compiler.use(compilerPlugin, options);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return compiler;
}

function createCompiler(options) {
  var compiler = createMdxAstCompiler(options);
  var compilerWithPlugins = applyHastPluginsAndCompilers(compiler, options);
  return compilerWithPlugins;
}

function sync(mdx, options) {
  var opts = Object.assign({}, DEFAULT_OPTIONS, options);
  var compiler = createCompiler(opts);
  var fileOpts = {
    contents: mdx
  };

  if (opts.filepath) {
    fileOpts.path = opts.filepath;
  }

  var _compiler$processSync = compiler.processSync(fileOpts),
      contents = _compiler$processSync.contents;

  return contents;
}

function compile(_x) {
  return _compile.apply(this, arguments);
}

function _compile() {
  _compile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mdx) {
    var options,
        opts,
        compiler,
        fileOpts,
        _yield$compiler$proce,
        contents,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            opts = Object.assign({}, DEFAULT_OPTIONS, options);
            compiler = createCompiler(opts);
            fileOpts = {
              contents: mdx
            };

            if (opts.filepath) {
              fileOpts.path = opts.filepath;
            }

            _context.next = 7;
            return compiler.process(fileOpts);

          case 7:
            _yield$compiler$proce = _context.sent;
            contents = _yield$compiler$proce.contents;
            return _context.abrupt("return", contents);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _compile.apply(this, arguments);
}

compile.sync = sync;
module.exports = compile;
exports = compile;
exports.sync = sync;
exports.createMdxAstCompiler = createMdxAstCompiler;
exports["default"] = compile;